import React from 'react'
import { useLocation } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { selectProfile } from '../../Containers/Client/selector';
import { connect, useDispatch } from 'react-redux';
import Profile from './Profile';
import Wallet from './Wallet';

function Settings({profile}) {
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location?.pathname?.split("/")[2];

  if (path === 'profile' && profile){
      return (
          <>
            <Profile profile={profile} dispatch={dispatch} />
            <Wallet profile={profile} dispatch={dispatch} />
          </>
      )
  }
  if (path === 'wallet' && profile){
      return (
          <>
            {/* <Wallet profile={profile} isModalOpen setIsModalOpen={setIsModalOpen()}/> */}
          </>
      )
  }
}
const mapStateToProps = createStructuredSelector({
    profile: selectProfile,
})
export default connect(mapStateToProps)(Settings)